module.exports = __webpack_public_path__ + "static/media/carb.ade9a721.png";